import VueCookie from 'vue-cookie';

export class AuthService {
    static setToken(token){
        VueCookie.set('token', token);
    }
    static getToken(){
        return VueCookie.get('token');
    }
    static deleteToken(){
        return VueCookie.delete('token');   
    }
    static setUid(uid){
        VueCookie.set('uid', uid);
    }
    static getUid(){
        return VueCookie.get('uid');
    }
    static deleteUid(){
        return VueCookie.delete('uid');
    }
    static setTipusEntitat(tipusEntitat){
        VueCookie.set('tipusEntitat', tipusEntitat);
    }
    static getTipusEntitat(){
        return VueCookie.get('tipusEntitat');
    }
    static deleteTipusEntitat(){
        return VueCookie.delete('tipusEntitat');
    }

}




// WEBPACK FOOTER //
// ./src/login/services/authService.js